import React, { Component } from "react";
import { TextField } from "@rmwc/textfield";
import { connect } from "react-redux";
import { Select } from "@rmwc/select";
import {
  commonConfirmationAlert,
  handleCloseforDoorWindows,
  DeviceCapture,
  handleShowPhotoModal,
  getSelectedTab,
} from "../../action/index.js";
import {
  captureBlobImages,
  addSluginToBlobImages,
  showImageEditor,
} from "../../action/extra_options/orderExtras.action.js";
import ImageEditorNew from "../Modals/ImageEditorNew";
import AnimButton from "../Button/AnimButton.js";
class CaptureScreen extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
        selectedItem: -1,
      }
      this.handleResize = this.handleResize.bind(this);
    }

   CheckCaptureImage = () => {
      this.props.handleCloseforDoorWindows(1);
      this.props.captureBlobImages("manual");
      // console.log('this.props.const_var.i_g_A_y.length: ', this.props.const_var.i_g_A_y.length);
   };

   componentDidMount() {
      window.addEventListener('resize', this.handleResize);
   }

   componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
   }

   handleResize() {
      if(window.innerWidth < 992) {
         if(this.props.isShowPhotoModal) {
            this.props.handleShowPhotoModal()
            this.props.getSelectedTab('capture')
         }
      }
      else {
         if(this.props.const_var.selectedTabKeyForWheel === 'capture' && this.props.isShowPhotoModal && this.props.const_var.loginSession == true) {
            this.props.handleShowPhotoModal()
         }
      }
   }

   render() {
      return (
         <>
            <div className="capture-screen">
               {
                  this.props.const_var.i_g_A_y.length > 0 ? (
                     <>
                        {
                           this.props.const_var.i_g_A_y.length < 5 ?
                           <div className="clicking-capture-wrapper">
                              <div className="clicking-capture-box ">
                                 {
                                    <div className="clicking-capture-cta">
                                       <button 
                                          className={'btn btn-primary'}
                                          onClick={()=>this.props.const_var.i_g_A_y.length > 4 ? this.props.commonConfirmationAlert("captuareIMG") : this.CheckCaptureImage()}
                                       >
                                          <i className="icon-photos-ico icon"></i><span> CAPTURE</span>
                                       </button>
                                    </div>
                                 }
                              </div>
                           </div>
                           :
                           <div className="info-wrapper">
                              Psst!! You can only click 5 photos. Please consider removing the OKish photo to click another best one.
                           </div>
                        }

                        <div className="capture-views-wrapper">
                           <div className="more-photos" onClick={() => this.props.handleShowPhotoModal()}>
                              <i className="icon-double-arrow-ico"></i>
                              Captured More Photos
                           </div>
                           {Object.entries(this.props.const_var.i_g_A_y).map(
                           ([key, value], index) => {
                              if (
                                 value.image_name != "2D Layout" &&
                                 value.image_name != "2D Layout1" &&
                                 value.image_name != "ig-image"
                              ) {
                                 if (value.description != null) {
                                 value.is_description = true;
                                 }

                                 return (
                                 <div
                                    className="capture-view-sec"
                                    id={`scrollid${key}`}
                                    key={key}
                                 >
                                    
                                    <div className="capture-action-cta">
                                       <a
                                          className="anchor-secondary edit-capture"
                                          onClick={(e) =>
                                             this.props.showImageEditor(
                                                e,
                                                value.image,
                                                true,
                                                key
                                             )
                                          }
                                       >
                                       <span className="icon-edit-ico icon"></span>
                                       </a>
                                       <a
                                          className="anchor-secondary remove-capture"
                                          onClick={
                                             (e) =>{
                                                this.setState({selectedItem: index})
                                                if(this.state.selectedItem === index) {
                                                   this.setState({selectedItem: -1})
                                                }
                                             }
                                          }
                                       >
                                       <span className="icon-delete icon"></span>
                                       </a>
                                       {
                                          this.state.selectedItem === index &&
                                          <div className="delete-tooltip">
                                             <div className="alert-title">ALERT!!</div>
                                             <div className="alert-content">Are you sure you want to delete this image?</div>
                                             <button
                                                className="btn btn-danger" 
                                                onClick={(e) =>
                                                   {
                                                      this.props.addSluginToBlobImages(e, key, "")
                                                      this.props.handleCloseforDoorWindows(1);
                                                      this.setState({selectedItem: -1})
                                                   }
                                                }
                                             >
                                                YES DELETE
                                             </button>
                                             <i className='icon-close' onClick={() => this.setState({selectedItem: -1})}></i>
                                          </div>
                                       }
                                    </div>

                                    <div className="capture-view">
                                       <div className="row row align-items-end">
                                          <aside className="col-12">
                                             <div className="capture-view-img">
                                                <img src={value.image} />
                                             </div>
                                          </aside>
                                       </div>

                                       <div className="add-capture-description">
                                       {
                                          value.is_description !== true ? 
                                             (
                                                <a
                                                   onClick={(e) =>
                                                      this.props.addSluginToBlobImages(e, key, "is_description")
                                                   }
                                                >
                                                   <span class="icon-plus icon"></span>
                                                   <span class="text">Add Title & Description</span>
                                                </a>
                                             ) : 
                                             <div className="floating-label-input remove-helper-line">
                                                <TextField
                                                   placeholder="Add Title here..."
                                                   maxLength="25"
                                                   onChange={(e) =>
                                                      this.props.addSluginToBlobImages(e, key, "image_name")
                                                   }
                                                   value={value.image_name}
                                                   name="image_name"
                                                />
                                                <TextField
                                                   textarea
                                                   value={
                                                      value.description != null ? value.description : ""
                                                   }
                                                   fullwidth
                                                   placeholder="Write description here..."
                                                   maxLength={1000}
                                                   characterCount
                                                   helpText={{
                                                      persistent: true,
                                                   }}
                                                   onChange={(e) =>
                                                      this.props.addSluginToBlobImages(e, key, "description")
                                                   }
                                                />
                                             </div>
                                          }
                                       </div>
                                    </div>
                                 </div>
                                 );
                              }
                           }
                        )}
                     </div>
                  </>
               ) : 
                  <div className="no-images-found">
                     <div
                        className={
                        this.props.const_var.i_g_A_y.length == 0
                           ? "no-images-found-inner"
                           : "no-images-found-inner d-none"
                        }
                     >
                        <span className="side-icon"></span>
                        <span className="side-icon"></span>
                        <span className="side-icon"></span>
                        <span className="side-icon"></span>
                        <p>
                           There are no building photos Captured. <br />
                           If you wish to capture the photos.<br />
                           "Set a great angle & zoom level on the screen and click capture"
                        </p>
                        <button className="btn btn-primary" onClick={(e) => this.CheckCaptureImage()}>
                           CAPTURE
                        </button>
                     </div>
                     {this.props.const_var.i_g_A_y.length > 0 &&
                        this.props.const_var.i_g_A_y.length != 5 ? (
                           <div>
                              <a
                                 className="capture-more-cta"
                                 onClick={(e) => this.props.DeviceCapture("", "")}
                              >
                                 <span className="icon icon-arrow-down"></span>
                                 <span className="text">CAPTURE MORE PHOTOS</span>
                              </a>
                           </div>
                        ) : null}
                  </div>
               }

               <ImageEditorNew />
               <p className='testingscroll'></p>
            </div>
         </>
      );
   }
}

const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.orderExtrasReducer, ...state.eventReducer };
};
const mapDispatchToProps = {
  commonConfirmationAlert,
  captureBlobImages,
  commonConfirmationAlert,
  handleCloseforDoorWindows,
  addSluginToBlobImages,
  showImageEditor,
  DeviceCapture,
  handleShowPhotoModal,
  getSelectedTab
};

export default connect(mapStateToProps, mapDispatchToProps)(CaptureScreen);
